import { mapState } from 'vuex';
import { clone, get } from 'lodash';
export default {
  name: 'CoreDtwinStateEditValue',
  props: {
    // the current edited binding
    lclModel: {
      type: Object,
      required: true
    },
    // is this an edit or new creation?
    mode: {
      type: String,
      required: false,
      default: () => 'edit'
    },
    templateContext: {
      type: Boolean,
      required: false,
      default: false
    },
    stateEditable: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      valueWasChanged: false,
      stateIsNull: get(this.lclModel, 'value.value') === null,
      skipValueSaving: false,
      skipTransformer: true,
      requiredRule: [v => !!v || this.$i18n_t('Common.fieldRequired')],
      jsonErrorMsg: ''
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    isSuperSystemAdmin() {
      return this.permissions['super.system.manage'];
    },
    stateValue() {
      if (this.lclModel.properties.valueType === 'json') {
        try {
          return JSON.stringify(get(this.lclModel, 'value.value'), null, 1);
        } catch (error) {
          console.error(error);
        }
      }
      return `${get(this.lclModel, 'value.value')}`;
    },
    typeItems() {
      return ['number', 'boolean', 'string', 'json'];
    },
    jsonRule() {
      return [v => !!v || this.$i18n_t('Common.fieldRequired'), v => {
        try {
          JSON.parse(v);
        } catch (error) {
          return this.$i18n_t('DigitalTwin.DigitalTwin.states.invalidJSON');
        }
        return true;
      }];
    }
  },
  watch: {
    stateIsNull(val, oldVal) {
      if (val === true && oldVal !== true) {
        this.lclModel.value.value = null;
      }
    },
    stateValue() {
      this.stateIsNull = get(this.lclModel, 'value.value') === null;
    },
    'lclModel.properties.valueType': function (newVal) {
      if (newVal === 'boolean') {
        this.lclModel.value.value = false;
      }
    },
    lclModel() {
      this.cleanupBooleanValue();
    }
  },
  mounted() {
    if (!this.lclModel.value) {
      this.lclModel.value = {};
    }
    this.cleanupBooleanValue();
  },
  methods: {
    clickedBoolRadio() {
      this.valueWasChanged = true;
      this.lclModel.value = clone(this.lclModel.value);
    },
    cleanupBooleanValue() {
      if (this.lclModel.properties.valueType === 'boolean') {
        if (get(this.lclModel, 'value.value') !== true && get(this.lclModel, 'value.value') !== false && get(this.lclModel, 'value.value') !== null) {
          this.lclModel.value.value = false;
          this.valueWasChanged = true;
          this.$emit('input');
        }
      }
    },
    valueFieldEdited(e) {
      if (this.lclModel.properties.valueType === 'json') {
        try {
          this.jsonErrorMsg = '';
          this.lclModel.value.value = JSON.parse(e);
        } catch (_) {
          this.jsonErrorMsg = this.$i18n_t('DigitalTwin.DigitalTwin.states.invalidJSON');
        }
      } else if (this.lclModel.properties.valueType === 'boolean') {
        // the used vuetify-version seems to have a bug with radio-groups and null values
        // which uses the index instead of null, so have to hardcode this here
        // https://github.com/vuetifyjs/vuetify/issues/8876
        if (get(this.lclModel, 'value.value') === 2) {
          this.lclModel.value.value = null;
        }
      }
      this.valueWasChanged = true;
      this.lclModel.value.time = new Date().toISOString();
      this.$emit('input');
    },
    saveState() {
      if (this.lclModel.properties.valueType === 'number') {
        this.lclModel.value.value = parseFloat(get(this.lclModel, 'value.value'));
      }
      if (this.skipValueSaving) {
        this.lclModel.value.hasChanged = false;
        this.lclModel.value.skipTransformer = true;
        // for create-actions, no initial value
        this.lclModel.noUpdate = true;
      } else {
        this.lclModel.value.hasChanged = this.valueWasChanged;
        this.lclModel.value.skipTransformer = this.skipTransformer;
      }
    }
  }
};